import React from "react";

import { Stack, Divider, SelectChangeEvent } from "@mui/material";

import SettingsTitle from "@app/analytics/account/components/SettingsTitle";
import type { SettingsModuleProps } from "@app/analytics/account/types";
import WorkspaceSettingsAccordion from "@app/analytics/account/WorkspaceSettings/components/WorkspaceSettingsAccordion";
import type { CalendarPermissionLevel } from "@app/analytics/types";
import Dropdown from "@app/common/components/Dropdown";
import DropdownMenuItem from "@app/common/components/Dropdown/DropdownMenuItem";
import { getSelectedFromOptions } from "@app/common/components/Dropdown/utils";
import { TOOLTIPS } from "@app/common/content";

import { MEETING_ROLE, MEETING_TYPES } from "../constants";

const MeetingPreferencesModule = ({
  settings,
  onSettingUpdate,
  workspaceIsInactive,
}: SettingsModuleProps) => {
  const handleMeetingRoleUpdate = (event: SelectChangeEvent) => {
    onSettingUpdate({
      calendarPermissionLevel: event.target.value as CalendarPermissionLevel,
    });
  };

  const handleMeetingTypesUpdate = (event: SelectChangeEvent) => {
    const value = event.target.value === "true";
    onSettingUpdate({ calendarJoinInternalOnly: value });
  };

  return (
    <WorkspaceSettingsAccordion
      title="Join Preferences"
      subtitle="Customize which meetings in this Workspace Read can measure"
      sx={{
        borderTop: "1px solid",
        borderRadius: 0,
        borderColor: "shades.neutral.100",
      }}
    >
      <Stack spacing={1.5}>
        <SettingsTitle title={MEETING_ROLE.title} />
        <Dropdown
          disabled={workspaceIsInactive}
          selectedItem={getSelectedFromOptions(
            MEETING_ROLE.options,
            settings.calendarPermissionLevel
          )}
          name={MEETING_ROLE.name}
          onChange={handleMeetingRoleUpdate}
          sx={{ width: "600px", maxWidth: "100%" }}
          tooltip={
            workspaceIsInactive ? TOOLTIPS.upsell.upgradeToPro : undefined
          }
          wrapperSx={{ maxWidth: "600px" }}
        >
          {MEETING_ROLE.options.map((item) => {
            const isSelectedItem =
              item.value === settings.calendarPermissionLevel;
            return (
              <DropdownMenuItem
                key={item.value}
                {...item}
                selected={isSelectedItem}
              />
            );
          })}
        </Dropdown>
      </Stack>
      <Divider />
      <Stack spacing={1.5}>
        <SettingsTitle title={MEETING_TYPES.title} />
        <Dropdown
          disabled={workspaceIsInactive}
          selectedItem={getSelectedFromOptions(
            MEETING_TYPES.options,
            `${settings.calendarJoinInternalOnly}`
          )}
          name={MEETING_TYPES.name}
          onChange={handleMeetingTypesUpdate}
          sx={{ width: "600px", maxWidth: "100%" }}
          tooltip={
            workspaceIsInactive ? TOOLTIPS.upsell.upgradeToPro : undefined
          }
          wrapperSx={{ maxWidth: "600px" }}
        >
          {MEETING_TYPES.options.map((item) => {
            const isSelectedItem =
              item.value === `${settings.calendarJoinInternalOnly}`;
            return (
              <DropdownMenuItem
                key={item.value}
                {...item}
                selected={isSelectedItem}
              />
            );
          })}
        </Dropdown>
      </Stack>
    </WorkspaceSettingsAccordion>
  );
};

export default MeetingPreferencesModule;
